// Auto-generated by scripts/build.js — do not edit by hand.
const version = '3.0.1-810';
export default version;
